module.exports = __webpack_public_path__ + "static/img/guaduan.3545ab2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/guaduan.png
// module id = FvKL
// module chunks = 24